// frontend/src/components/PublicRoute/PublicRoute.jsx

import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// import { AppContext } from '../../AppContext';
import { AuthContext } from '../../contexts/AuthContext';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

const PublicRoute = () => {
    const { isAuthenticated, isSessionLoading } = useContext(AuthContext);

    if (isSessionLoading) {
        // Show a full-page loader while checking the session
        return (
            <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
                <LoadingIndicator message="Initializing Session..." />
            </div>
        );
    }

    // If session is checked and user IS authenticated, redirect them away from public pages to the main app
    if (isAuthenticated) {
        return <Navigate to="/app" />;
    }

    // If session is checked and user is NOT authenticated, show the public page (e.g., LandingPage, AuthPage)
    return <Outlet />;
};

export default PublicRoute;